import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const freeSpinsList = createAsyncThunk(
  "freeSpinsList/freeSpinsList",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("freespins/get-all", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const freeSpinsListSlice = createSlice({
  name: "freeSpinsList",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(freeSpinsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(freeSpinsList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(freeSpinsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default freeSpinsListSlice.reducer;
